import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import React, { useState } from "react";
import styles from "@/styles/userPage/CouponSection.module.scss";
import { useStore } from "@/store/index";
import { getCoupons } from "@/store/user/selectors-user";
import Btn from "@/components/common/Btn";
import { EBtnType } from "@/models/common/enums";
import AddCouponForm from "./AddCouponForm";

const Coupon = () => {
    const coupons = useStore(getCoupons);
    const [openCouponForm, setOpenCouponForm] = useState(false);

    return (
        <div className={styles.container}>
            <MDBRow>
                <MDBCol>
                    <p className={styles.couponTitleSection}>Coupons</p>
                </MDBCol>
            </MDBRow>
            <MDBRow className={styles.bg}>
                <MDBCol size={12} lg={6} className="my-3">
                    <MDBRow>
                        <MDBCol size={12}>
                            <>
                                <MDBRow>
                                    <span className={styles.coupon}>
                                        Coupons
                                    </span>
                                </MDBRow>
                                <MDBRow className="mt-2">
                                    <MDBCol size={12} lg={6}>
                                        {coupons?.length ? (
                                            coupons?.map(curr => (
                                                <p
                                                    key={curr}
                                                    className={
                                                        styles.couponInfo
                                                    }
                                                >
                                                    {curr}
                                                </p>
                                            ))
                                        ) : (
                                            <span className={styles.couponInfo}>
                                                No coupons added
                                            </span>
                                        )}
                                    </MDBCol>
                                    <MDBCol size={12} lg={6}>
                                        <Btn
                                            className={styles.addCoupon}
                                            onClick={() =>
                                                setOpenCouponForm(
                                                    !openCouponForm
                                                )
                                            }
                                            btnType={EBtnType.TRANSPARENT}
                                        >
                                            {openCouponForm ? "Close" : "Add"}
                                        </Btn>
                                    </MDBCol>
                                </MDBRow>
                            </>
                        </MDBCol>

                        {openCouponForm && <AddCouponForm />}
                    </MDBRow>
                </MDBCol>
                <MDBCol size={12} lg={6} className="my-3 d-none">
                    <MDBRow>
                        <MDBCol size={9} lg={6}>
                            <MDBRow>
                                <span className={styles.coupon}>
                                    Gift credit
                                </span>
                            </MDBRow>
                            <MDBRow>
                                <span className={styles.couponInfo}>
                                    No gift credit added
                                </span>
                            </MDBRow>
                        </MDBCol>
                        <MDBCol size={3} lg={6}>
                            <Btn
                                className={styles.addCoupon}
                                onClick={() =>
                                    setOpenCouponForm(!openCouponForm)
                                }
                                btnType={EBtnType.TRANSPARENT}
                            >
                                Add
                            </Btn>
                        </MDBCol>
                    </MDBRow>
                </MDBCol>
            </MDBRow>
        </div>
    );
};

export default Coupon;
